/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import InputText from '../../../../shared/AOForm/components/InputText/InputText';
import ItemTitle from "../ItemTitle/index";

export default class EmailGroup extends React.Component {
  constructor(props) {
    super(props);

    this.inputHandler = this.inputHandler.bind(this);
    this.setupData(props);
  }

  inputHandler = (questionRel, val, event)=> {
    /*
    * 1. only allow input number 0-9 and underline.
    * 2. callback the onChange action.
    */

    const {
      onChangeAction
    } = this.props;

    if (val !== '' && !/[A-Za-z0-9\-_]+/.test(val)) {
      return false;
    }

    onChangeAction && onChangeAction(questionRel, val, event);
  };

  setupData(props) {
    /*
    * setup component required props.
    */

    const {
      content,
      questionRel,
    } = props;

    content.dataKey = questionRel.questionIndicator;
    this.questionObj = {
      questionMark: content.questionMark || null,
      question: content || {},
      questionTip: content.questionTip || null
    };
  }

  deleteAction = (event) => {
    /*
    * callback the onClick action for the "Delete" button.
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const { onDelAction, questionRel } = this.props;
    const deleteIndex = Number(event.target.getAttribute('data-index'));
    onDelAction && onDelAction(questionRel, deleteIndex);

    return false;
  };

  addAction = (event) => {
    /*
    * callback the onClick action for the "Add" button.
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const { onAddAction, questionRel } = this.props;
    onAddAction && onAddAction(questionRel);

    return false;
  };

  componentWillReceiveProps(nextProps) {
    this.setupData(nextProps)
  }

  render() {
    const {
      content,
      itemArray,
      addBtnText,
      removeText,
      questionRel,
      repeatMax,
      handleBlurAction
    } = this.props;

    const addBtnStatus = (repeatMax && repeatMax <= itemArray.length) ? 'none': '';
    const emailGroupTitle = content && content.title && content.title;
    return (
      <div className="dynamic-group email-group clearfix">
        { content && content.title && <ItemTitle content={ this.questionObj } /> }

        {
          itemArray && itemArray.map((item, index) => {
            return (
              <div className="dynamic-item clearfix" key={`emailGroup_${index}`} data-key={`group_${index}`}>
                  <InputText
                    content={ item }
                    handleTextChange={ this.inputHandler }
                    handleTextDel={ this.deleteAction }
                    hasDelBtn={ itemArray.length > 1 }
                    index={ index }
                    dataIndex={ index }
                    type={'email'}
                    removeText={ removeText }
                    handleBlurAction={ handleBlurAction }
                    isNeedLabel={ false }
                    ariaLabel={ emailGroupTitle }
                  />
              </div>
            )
          })
        }
          <div className="add-btn-row" style={{display: addBtnStatus}}>
              <Button onClick={ this.addAction } disabled={false} data-key={ `${questionRel.questionIndicator}-${addBtnText.dataKey}` }>
                  <i aria-hidden={true} className="icon icon-add">{}</i>
                { addBtnText.text }
              </Button>
          </div>
      </div>
    )
  }
};

EmailGroup.propTypes = {
  content: PropTypes.object,
  itemArray: PropTypes.array.isRequired,
  onChangeAction: PropTypes.func,
  onDelAction: PropTypes.func,
  onAddAction: PropTypes.func,
  addBtnText: PropTypes.object,
  removeText:PropTypes.string,
  questionRel: PropTypes.object,
  repeatMax: PropTypes.number,
  handleBlurAction:PropTypes.func
};

EmailGroup.defaultProps = {
  itemArray: [],
  disabled: false
};



// WEBPACK FOOTER //
// ./src/shared/AOForm/components/EmailGroup/index.js